var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.Enums),expression:"!Enums"}],staticClass:"app-main"},[(_vm.Enums)?[(_vm.hasPermission)?[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)]:[_c('page404')]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }